<template>
  <a-modal
    :title="!isEdit ? $t('page_ops_customer_new_customer') : $t('page_ops_customer_edit_customer')"
    :visible="visible"
    @cancel="cancel"
    @ok="ok"
    :width="800"
    :confirmLoading="confirmLoading"
  >
    <a-form
      :form="form"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 17 }"
      :confirmLoading="loading"
    >
      <a-row>
        <a-col :span="12">
          <a-form-item v-show="!isEdit" :label="$t('page_ops_customer_coding_rules')">
            <a-select
            show-search
            optionFilterProp="children"
              v-decorator="[
                'codeRuleId',
                {
                  initialValue: editItem.codeRuleId || undefined
                }
              ]"
              allowClear
              @change="handleSelectChange"
              :placeholder="$t('please_select') + $t('page_ops_customer_select_coding_rule')"
            >
              <a-select-option :key="index" :value="item.value" v-for="(item, index) in codeList">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_customer_code')">
            <a-input
              :placeholder="$t('common_please_input') + $t('page_ops_customer_enter_customer_code')"
              :disabled="isEdit || codeId !== undefined"
              v-decorator="[
                'code',
                {
                  initialValue: editItem.code || ''
                }
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_customer_name')">
            <a-auto-complete
              style="width: 100%"
              v-decorator="[
                'name',
                {
                  initialValue: editItem.name || '',
                  rules: [
                    {
                      required: true,
                      max: 48,
                      message: $t('page_material_warehousing_custom_input48')
                    }
                  ]
                }
              ]"
              :data-source="dataSource"
              :placeholder="$t('common_please_input') + $t('page_ops_customer_enter_customer_name')"
              @search="onSearchCustomer"
            />
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_contacts')">
            <a-input
              v-decorator="[
                'contact',
                {
                  initialValue: editItem.contact || ''
                }
              ]"
              :placeholder="$t('common_please_input') + $t('page_ops_customer_enter_contact')"
            />
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_contact_number')">
            <a-input
              v-decorator="[
                'tel',
                {
                  initialValue: editItem.tel || '',
                  rules: [
                    {
                      validator: checkPhone,
                      trigger: 'change'
                    }
                  ]
                }
              ]"
              :placeholder="$t('common_please_input') + $t('page_ops_customer_enter_contact_number')"
            />
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_data_permissions')">
            <!-- tree-checkable -->
            <a-tree-select
              v-decorator="[
                'createDept',
                {
                  initialValue: editItem.createDept || '',
                  rules: [
                    {
                      required: true,
                      message: $t('page_ops_customer_select_data_permission') + '!'
                    }
                  ]
                }
              ]"
              style="width: 100%"
              :tree-data="treeData"
              :multiple="false"
              :search-placeholder="$t('please_select') + $t('page_ops_customer_select_data_permission')"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('page_ops_customer_province')">
            <a-select
              show-search
              optionFilterProp="children"
              :placeholder="$t('please_select') + $t('page_ops_customer_select_province')"
              v-decorator="[
                'provinceId',
                {
                  initialValue: editProvince,
                  rules: [
                    { required: true, message: $t('page_ops_customer_select_province') + '!' }
                  ]
                }
              ]"
              @change="handleProvinceChange"
            >
              <a-select-option :key="item.code" :value="item.code" v-for="item in provinceList">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_city')">
            <a-select
              show-search
              optionFilterProp="children"
              :placeholder="$t('please_select') + $t('page_ops_customer_select_city')"
              v-decorator="[
                'cityId',
                {
                  initialValue: editCity,
                  rules: [{ required: true, message: $t('page_ops_customer_select_city') + '!' }]
                }
              ]"
              @change="handleCityChange"
            >
              <a-select-option :key="item.code" :value="item.code" v-for="item in cityList">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('page_ops_customer_detailed_address')">
            <a-textarea
              :placeholder="$t('common_please_input') + $t('page_ops_customer_enter_detailed_address')"
              v-decorator="[
                'address',
                {
                  initialValue: editItem.address || '',
                  rules: [
                    {
                      required: true,
                      message: $t('page_ops_customer_enter_detailed_address') + '!'
                    }
                  ]
                }
              ]"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-item>
          <a-form-item v-if="editItem.id" :label="$t('page_ops_customer_historical_address')">
            <a-select
                v-model="selectAddress"
                show-search
                :placeholder="$t('please_select')"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                @change="handleAddressChange"
            >
              <a-select-option  v-for="item in addressList" :key="item.id" :value="item.id">
                {{ item.provinceName }}{{item.cityName}}{{item.address}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-transfer
        :data-source="machineList"
        :list-style="{
          width: '350px',
          height: '400px',
          overflow: 'auto'
        }"
        :showSelectAll="true"
        :titles="[$t('page_ops_customer_unbound_machine'), $t('page_ops_customer_bound_machine')]"
        showSearch
        :target-keys="customerIds"
        :render="renderItem"
        @change="handleChange"
      />
    </a-form>
  </a-modal>
</template>

<script>
import {
  AuthorityDomainServiceProxy,
  RegionServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { CustomerServiceProxy, CustomerHistoryAddressServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {isCellphoneNo}  from "@/utils/validate"

const machineService = new MachineServiceProxy()
const customerHistoryAddressService = new CustomerHistoryAddressServiceProxy()
const adsp = new AuthorityDomainServiceProxy()
const rsp = new RegionServiceProxy()
const customerService = new CustomerServiceProxy()

import R from 'ramda'

const resetProp = (from, to) => R.pipe(R.prop(from), R.objOf(to))

const tranformTreeShape = (data) => {
  const setLabel = resetProp('title', 'label')
  const setValue = resetProp('id', 'value')
  const setChildren = R.pipe(
    R.prop('children'),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf('children'))
    )
  )

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(data)
}

let timeout
let currentValue

function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout)
    timeout = null
  }
  currentValue = value

  function getCustomers() {
    customerService.getCustomers(value).then((result) => {
      if (currentValue === value) {
        const data = []
        result.forEach((r) => {
          data.push(r['name'])
        })
        callback(data)
      }
    })
  }

  timeout = setTimeout(getCustomers, 300)
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    dataItem: {
      type: Object,
      default: () => ({})
    },
    codeList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    editProvince() {
      let value = ''
      if (this.editItem && this.editItem.provinceName) {
        const item = this.provinceList.find((res) => res.name === this.editItem.provinceName)
        if (item) {
          value = item.code
        }
        this.getCityList(value)
      }
      return value
    },
    editCity() {
      let value = ''
      if (this.editItem && this.editItem.cityName) {
        const item = this.cityList.find((res) => res.name === this.editItem.cityName)
        if (item) {
          value = item.code
        }
      }
      return value
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      provinceList: [],
      cityList: [],
      treeData: [],
      machineList: [],
      customerIds: [],
      cityValue: '',
      codeId: undefined,
      dataSource: [],
      customerName: '',
      confirmLoading: false,
      addressList: [],
      selectAddress: '',
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          if (this.editItem.id && this.isEdit) {
            this.customerName = this.editItem.name
          } else {
            this.customerName = ''
          }
          this.reload()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleAddressChange(value) {
      this.selectAddress = value;
      const data = this.addressList.find(v=>v.id===value);
      if(Object.keys(value).length) {
        const {provinceName, cityName, address, areaName } = data;
        const depts = this.treeData[0].children;
        const deptId = depts.find(v=>v.label=== areaName)?.value;
        this.editItem.provinceName =provinceName;
        this.editItem.cityName = cityName;
        this.editItem.address = address;
        this.editItem.createDept = deptId;
      }
    },
    checkPhone(rule, value, callback){
      if (value !== '') {
        if(!isCellphoneNo(value)){
          const msg = this.$t('page_personal_phone_valid_tip');
          callback(new Error(msg.toString()))
        }else{
          callback()
        }
      }else{
        callback()
      }
    },
    async reload() {
      await this.getCustomerMachineList()
      await this.getAuthorityDomainList()
      this.provinceList = await this.getRegionList()
      if(this.editItem && this.editItem.id) {
        await this.getHistoricalAddress(this.editItem.id)
      }
    },
    getHistoricalAddress(customerId) {
      customerHistoryAddressService.page(1,{customerId},1000).then(res=>{
        const {data:{records}} = res
        this.addressList = records || []
      })
    },
    async getCustomerMachineList() {
      let customerMachineList = []

      if (this.editItem.id && this.isEdit) {
        customerMachineList = await this.getMachineList(this.editItem.id, true)
      }

      let machineList = (await machineService.getAssignableMachineList(1, -1)).records
      machineList = machineList.concat(customerMachineList)
      this.machineList = machineList.map((res) => {
        const data = {
          key: res.id,
          title: res.name,
          description: res.code,
          isShared: res.isShared
        }
        return data
      })
      this.customerIds = customerMachineList.map((res) => {
        return res.id
      })
    },
    renderItem(item) {
      const customLabel = (
        <span class="custom-item">
          {item.description} - {item.title}
        </span>
      )

      return {
        label: customLabel, // for displayed item
        value: item.description+'-'+item.title // for title and filter matching
      }
    },
    handleChange(targetKeys) {
      this.customerIds = targetKeys
    },
    handleSelectChange(value) {
      this.codeId = value
    },
    async handleProvinceChange(value) {
      const {areaName} = this.provinceList.find(v=>v.code===value)
      const depts = this.treeData[0].children;
      const deptId = depts.find(v=>v.label=== areaName)?.value;
      this.editItem.createDept = deptId;
      this.getCityList(value)
      if (this.cityValue) {
        this.form.setFieldsValue({
          cityId: ''
        })
      }
    },
    handleCityChange(value) {
      this.cityValue = value;
    },
    onSearchCustomer(searchText) {
      fetchCustomers(searchText, (data) => (this.dataSource = data))
    },
    cancel() {
      this.codeId = undefined;
      this.selectAddress = '';
      this.form.resetFields()
      this.$emit('cancel')
    },
    async ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = { ...values }
          let province = this.provinceList.find((res) => res.code === values.provinceId)
          data.areaName = province.areaName
          data.provinceName = province.name
          data.cityName = this.cityList.find((res) => res.code === values.cityId).name

          const list = []
          this.machineList.forEach((res) => {
            if (this.customerIds.indexOf(res.key) === -1 && res.isShared) {
              list.push(res)
            }
          })

          if (list && list.length) {
            this.$error({
              title:
                (this.isEdit ? this.$t('edit') : this.$t('create')) +
                this.$t('page_ops_customer_fail'),
              icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
              content: h('div', {}, [
                h('p', this.$t('page_ops_customer_share_not_move')),
                list.map((res) => {
                  return h('p', res.description + '-' + res.title)
                })
              ]),
              okText: this.$t('ok'),
              okType: 'danger'
            })
            return
          }

          const ids = this.customerIds
          if (ids && ids.length) {
            data.workStationIds = ids.join(',')
          } else {
            data.workStationIds = ''
          }
          this.updata(data)
        }
      })
    },
    async updata(values) {
      this.confirmLoading = true
      setTimeout(() => {
        this.confirmLoading = false
      }, 3000)
      if (!this.isEdit) {
        await customerService.createCustomer(values)
      } else {
        await customerService.updateSupplier(values, this.editItem.id)
      }
      this.$message.success(
        !this.isEdit
          ? this.$t('page_ops_customer_new_success')
          : this.$t('page_ops_customer_edit_succee')
      )
      // data.name = this.customerName
      this.$emit('ok')
      this.codeId = undefined
      this.customerName = ''
      this.form.resetFields()
    },
    async getCityList(value) {
      this.cityList = await (await rsp.select(value)).data
    },
    async getRegionList() {
      return await (await rsp.selectByLevel()).data
    },
    async getMachineList(id, isAssigned) {
      const dto = {
        customerId: id,
        isAssigned: isAssigned
      }
      return await (await machineService.getMachineList(1, dto, -1)).records
    },

    async getAuthorityDomainList() {
      const { data } = await adsp.getEnableTreeList()
      const tree = tranformTreeShape(data[0])
      tree.selectable = false
      this.treeData = [tree]
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-transfer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .ant-transfer-list-header {
  background: #f8f8f8;
  font-weight: bold;
}
/deep/ .ant-modal-header {
  background: #f8f8f8;
  font-weight: bold;
}
/deep/ .ant-modal-footer {
  background: #f8f8f8;
}
.buttom-save-primary {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
  color: #fff;
}
/deep/ .ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 16px;
}
/deep/ .ant-btn-icon-only.ant-btn-sm {
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 14px;
  border-radius: 0;
}
</style>
